export const showContact = () => {
  const salesmartlyQueue = (window as Window & { ssq?: { push: (command: string) => void } }).ssq
  if (salesmartlyQueue?.push) {
    salesmartlyQueue.push('chatOpen')
    return
  }

  const iframe = document.getElementById('s-chat-plugin') as HTMLIFrameElement
  if (!iframe) return
  const chatBtn = iframe.contentWindow?.document?.querySelector(
    '.Chat_icon__wrap_3840H',
  ) as HTMLElement
  if (chatBtn) chatBtn.click()
}
